var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "max-w-4xl h-auto flex items-center justify-center h-auto flex-wrap mx-auto my-28 lg:my-0 pt-5"
    },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass:
            "bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md w-full lg:w-4/5",
          attrs: {
            role: "alert"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex"
            },
            [
              _c(
                "div",
                {
                  staticClass: "py-1"
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "fill-current h-6 w-6 text-teal-500 mr-4",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                        }
                      })
                    ]
                  )
                ]
              ),
              _c("div", [
                _c(
                  "p",
                  {
                    staticClass: "font-bold mb-0"
                  },
                  [_vm._v("GreenGeeks Seal")]
                ),
                _c(
                  "p",
                  {
                    staticClass: "text-sm mb-0"
                  },
                  [
                    _vm._v(
                      " Login to your account and visit the Profile section to learn about GreenGeeks Seal. "
                    )
                  ]
                ),
                _c("br"),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "text-align": "center"
                    }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-transparent hover:bg-green-600 text-green-600 hover:text-white px-2 mt-2 border border-green-600 hover:border-transparent rounded",
                        on: {
                          click: function click($event) {
                            return _vm.startSession("login")
                          }
                        }
                      },
                      [_vm._v(" Login ")]
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "a",
      {
        staticClass: "no-underline hover:no-underline",
        attrs: {
          href: "https://www.greengeeks.com/"
        }
      },
      [
        _c("img", {
          staticClass: "mb-6",
          attrs: {
            alt: "GreenGeeks logo",
            src: "/static/img/amui/logo_black.png"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }